import { useCallback, useRef } from 'react';
import { useAppDispatch } from '../../../hooks';
import useNavItems from '../../../hooks/useNavItems';
import { togglePrimaryNavTooltip, toggleSubmenu } from '../../../reducers/navItems';
import useIsVerticalNavPinned from '../../../hooks/useIsVerticalNavPinned';
import { captureException } from '../../../utils/sentryAPI';
const isRelatedTargetAPrimaryNavItem = evt => {
  if (!evt.relatedTarget) return false;
  try {
    const relatedTarget = evt.relatedTarget;
    if (relatedTarget instanceof HTMLElement && relatedTarget.dataset.menuItemLevel === 'primary') {
      return true;
    }
  } catch (e) {
    captureException(e);
  }
  return false;
};
const useVerticalNavPrimaryMenuItemMouseBehaviors = () => {
  const {
    openMenus
  } = useNavItems();
  const isPinned = useIsVerticalNavPinned();
  const isMouseMovingTowardsSubmenu = useRef(false);
  const dispatch = useAppDispatch();
  const setIsMouseMovingTowardsSubmenu = useCallback(nextState => {
    isMouseMovingTowardsSubmenu.current = nextState;
  }, []);
  const onClick = useCallback(id => () => {
    dispatch(toggleSubmenu({
      id
    }));
    setIsMouseMovingTowardsSubmenu(false);
  }, [dispatch, setIsMouseMovingTowardsSubmenu]);
  const onMouseEnter = useCallback(({
    id
  }) => () => {
    if (!isPinned) {
      if (!openMenus.primary || openMenus.primary && openMenus.primary !== id) {
        setIsMouseMovingTowardsSubmenu(false);
        dispatch(toggleSubmenu({
          id
        }));
        return;
      }
    }
    if (isMouseMovingTowardsSubmenu.current) {
      return;
    }
    setIsMouseMovingTowardsSubmenu(false);
    if (openMenus.primary && openMenus.primary !== id) {
      dispatch(toggleSubmenu({
        id
      }));
      return;
    }
  }, [dispatch, isPinned, openMenus.primary, setIsMouseMovingTowardsSubmenu]);
  const onMouseEnterLink = useCallback(({
    id
  }) => () => {
    if (!isPinned) {
      dispatch(togglePrimaryNavTooltip({
        id
      }));
      return;
    }
  }, [dispatch, isPinned]);
  const onMouseLeaveLink = useCallback(evt => {
    if (isRelatedTargetAPrimaryNavItem(evt)) {
      return;
    }
    dispatch(togglePrimaryNavTooltip({
      id: undefined
    }));
  }, [dispatch]);
  return {
    onClick,
    onMouseEnter,
    isMouseMovingTowardsSubmenu,
    setIsMouseMovingTowardsSubmenu,
    onMouseEnterLink,
    onMouseLeaveLink
  };
};
export default useVerticalNavPrimaryMenuItemMouseBehaviors;